"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestApi = void 0;
var runtime = __importStar(require("../runtime"));
var DigestItemResponseDto_1 = require("../models/DigestItemResponseDto");
var PaginatedDigestFeedResponseDto_1 = require("../models/PaginatedDigestFeedResponseDto");
var PaginatedDigestItemsResponseDto_1 = require("../models/PaginatedDigestItemsResponseDto");
var ReportBrokenLinkDto_1 = require("../models/ReportBrokenLinkDto");
/**
 *
 */
var DigestApi = /** @class */ (function (_super) {
    __extends(DigestApi, _super);
    function DigestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for digestControllerAddFavouriteV1 without sending the request
     */
    DigestApi.prototype.digestControllerAddFavouriteV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['digestId'] == null) {
                    throw new runtime.RequiredError('digestId', 'Required parameter "digestId" was null or undefined when calling digestControllerAddFavouriteV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/digest/favourite/{digest_id}";
                urlPath = urlPath.replace('{digest_id}', encodeURIComponent(String(requestParameters['digestId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Add a digest to favourites
     */
    DigestApi.prototype.digestControllerAddFavouriteV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerAddFavouriteV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Add a digest to favourites
     */
    DigestApi.prototype.digestControllerAddFavouriteV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerAddFavouriteV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetByIdV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetByIdV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['digestId'] == null) {
                    throw new runtime.RequiredError('digestId', 'Required parameter "digestId" was null or undefined when calling digestControllerGetByIdV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/digest/{digest_id}";
                urlPath = urlPath.replace('{digest_id}', encodeURIComponent(String(requestParameters['digestId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get a specific digest by ID
     */
    DigestApi.prototype.digestControllerGetByIdV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetByIdV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, DigestItemResponseDto_1.DigestItemResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a specific digest by ID
     */
    DigestApi.prototype.digestControllerGetByIdV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetByIdV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetBySportV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetBySportV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['sportId'] == null) {
                    throw new runtime.RequiredError('sportId', 'Required parameter "sportId" was null or undefined when calling digestControllerGetBySportV1().');
                }
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/digest/sport/{sport_id}";
                urlPath = urlPath.replace('{sport_id}', encodeURIComponent(String(requestParameters['sportId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get all digests for a specific sport
     */
    DigestApi.prototype.digestControllerGetBySportV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetBySportV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PaginatedDigestItemsResponseDto_1.PaginatedDigestItemsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all digests for a specific sport
     */
    DigestApi.prototype.digestControllerGetBySportV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetBySportV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetFavouriteV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetFavouriteV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/digest/favourite";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get user\'s favourite digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetFavouriteV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetFavouriteV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PaginatedDigestFeedResponseDto_1.PaginatedDigestFeedResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user\'s favourite digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetFavouriteV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetFavouriteV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetFeedV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetFeedV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/digest/feed";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get user\'s digest feed grouped by sport
     */
    DigestApi.prototype.digestControllerGetFeedV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetFeedV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PaginatedDigestFeedResponseDto_1.PaginatedDigestFeedResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user\'s digest feed grouped by sport
     */
    DigestApi.prototype.digestControllerGetFeedV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetFeedV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetMissedV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetMissedV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/digest/missed";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get user\'s missed digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetMissedV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetMissedV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PaginatedDigestFeedResponseDto_1.PaginatedDigestFeedResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user\'s missed digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetMissedV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetMissedV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetSportsV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetSportsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/digest/sports";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get followed sports that have digests
     */
    DigestApi.prototype.digestControllerGetSportsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetSportsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get followed sports that have digests
     */
    DigestApi.prototype.digestControllerGetSportsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetSportsV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetUpcomingV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetUpcomingV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/digest/upcoming";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get user\'s upcoming digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetUpcomingV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetUpcomingV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PaginatedDigestFeedResponseDto_1.PaginatedDigestFeedResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user\'s upcoming digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetUpcomingV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetUpcomingV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerGetWatchedV1 without sending the request
     */
    DigestApi.prototype.digestControllerGetWatchedV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/digest/watched";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get user\'s watched digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetWatchedV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetWatchedV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PaginatedDigestFeedResponseDto_1.PaginatedDigestFeedResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user\'s watched digests grouped by sport
     */
    DigestApi.prototype.digestControllerGetWatchedV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerGetWatchedV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerMarkAsWatchedV1 without sending the request
     */
    DigestApi.prototype.digestControllerMarkAsWatchedV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['digestId'] == null) {
                    throw new runtime.RequiredError('digestId', 'Required parameter "digestId" was null or undefined when calling digestControllerMarkAsWatchedV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/digest/watched/{digest_id}";
                urlPath = urlPath.replace('{digest_id}', encodeURIComponent(String(requestParameters['digestId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Mark a digest as watched
     */
    DigestApi.prototype.digestControllerMarkAsWatchedV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerMarkAsWatchedV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Mark a digest as watched
     */
    DigestApi.prototype.digestControllerMarkAsWatchedV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerMarkAsWatchedV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerRemoveFavouriteV1 without sending the request
     */
    DigestApi.prototype.digestControllerRemoveFavouriteV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['digestId'] == null) {
                    throw new runtime.RequiredError('digestId', 'Required parameter "digestId" was null or undefined when calling digestControllerRemoveFavouriteV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/digest/favourite/{digest_id}";
                urlPath = urlPath.replace('{digest_id}', encodeURIComponent(String(requestParameters['digestId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'DELETE',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Remove a digest from favourites
     */
    DigestApi.prototype.digestControllerRemoveFavouriteV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerRemoveFavouriteV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove a digest from favourites
     */
    DigestApi.prototype.digestControllerRemoveFavouriteV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerRemoveFavouriteV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for digestControllerReportBrokenLinkV1 without sending the request
     */
    DigestApi.prototype.digestControllerReportBrokenLinkV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['digestId'] == null) {
                    throw new runtime.RequiredError('digestId', 'Required parameter "digestId" was null or undefined when calling digestControllerReportBrokenLinkV1().');
                }
                if (requestParameters['reportBrokenLinkDto'] == null) {
                    throw new runtime.RequiredError('reportBrokenLinkDto', 'Required parameter "reportBrokenLinkDto" was null or undefined when calling digestControllerReportBrokenLinkV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                urlPath = "/v1/digest/report/{digest_id}";
                urlPath = urlPath.replace('{digest_id}', encodeURIComponent(String(requestParameters['digestId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, ReportBrokenLinkDto_1.ReportBrokenLinkDtoToJSON)(requestParameters['reportBrokenLinkDto']),
                    }];
            });
        });
    };
    /**
     * Report a broken highlight link
     */
    DigestApi.prototype.digestControllerReportBrokenLinkV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerReportBrokenLinkV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Report a broken highlight link
     */
    DigestApi.prototype.digestControllerReportBrokenLinkV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestControllerReportBrokenLinkV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DigestApi;
}(runtime.BaseAPI));
exports.DigestApi = DigestApi;
